<script>
import Layout from "@/router/layouts/main";
import Breadcrumb from "@/components/Breadcrumb";
import { api } from "@/state/services";
import { voucherStatus, voucherStatuses, formatPoints, formatDate } from "@/state/helpers/experiences";

// Meus resgates: tabela no desktop e cartões no mobile
export default {
  components: { Layout, Breadcrumb },
  data() {
    return {
      loading: true,
      errored: false,
      list: [],
      search: "",
      status: null,
    };
  },
  computed: {
    statusOptions() {
      return [{ value: null, text: "Todos os status" }].concat(
        Object.keys(voucherStatuses).map((key) => ({ value: key, text: voucherStatuses[key].label }))
      );
    },
    filtered() {
      const term = this.search.trim().toLowerCase();
      return this.list.filter((item) => {
        if (this.status && item.status !== this.status) {
          return false;
        }
        if (term && [item.protocol, item.experience.title].join(" ").toLowerCase().indexOf(term) === -1) {
          return false;
        }
        return true;
      });
    },
  },
  methods: {
    voucherStatus,
    formatPoints,
    formatDate,
    load() {
      this.loading = true;
      this.errored = false;

      api
        .get("experiences/vouchers")
        .then((response) => {
          if (response.data.status == "success") {
            this.list = response.data.list || [];
          } else {
            this.errored = true;
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <Breadcrumb :items="[{ text: 'Experiências', to: '/experiences' }, { text: 'Meus resgates' }]" />

    <div class="ds-page">
      <div class="ds-intro">
        <h1 class="ds-title">Meus resgates</h1>
      </div>

      <div v-if="loading" class="text-center py-5">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else-if="errored" class="ds-box ds-result text-center">
        <p>Pedimos desculpas, não podemos recuperar as informações neste momento.</p>
        <button class="btn btn-default" v-on:click="load()">Tentar novamente</button>
      </div>
      <div v-else-if="list.length == 0" class="ds-box ds-result text-center">
        <i class="bx bx-gift ds-result-icon" aria-hidden="true"></i>
        <h4>Você ainda não resgatou nenhuma experiência</h4>
        <router-link tag="a" to="/experiences" class="btn btn-default btn-lg btn-block text-uppercase mt-4">Ver experiências</router-link>
      </div>
      <template v-else>
        <div class="ds-box ds-box-wide">
          <div class="row">
            <div class="col-md-8 mb-2">
              <b-form-input v-model="search" type="text" placeholder="Buscar por protocolo ou experiência"></b-form-input>
            </div>
            <div class="col-md-4 mb-2">
              <b-form-select v-model="status" :options="statusOptions"></b-form-select>
            </div>
          </div>
        </div>

        <div v-if="filtered.length == 0" class="ds-box ds-result text-center">
          <i class="bx bx-search ds-result-icon" aria-hidden="true"></i>
          <p class="mb-0">Nenhum resgate encontrado.</p>
        </div>
        <template v-else>
          <div class="ds-box ds-box-wide d-none d-md-block">
            <div class="table-responsive">
              <table class="table ds-table mb-0">
                <thead>
                  <tr>
                    <th>Protocolo</th>
                    <th>Data</th>
                    <th>Experiência</th>
                    <th class="text-right">Pontos</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in filtered" :key="item.protocol">
                    <td class="notranslate">{{ item.protocol }}</td>
                    <td>{{ formatDate(item.date) }}</td>
                    <td>
                      <div class="ex-product">
                        <div class="ex-cover-mini">
                          <div class="ex-cover">
                            <img v-if="item.experience.image" :src="item.experience.image" :alt="item.experience.title">
                            <span v-else class="ex-cover-empty"><i class="bx bx-gift font-size-18" aria-hidden="true"></i></span>
                          </div>
                        </div>
                        <span>{{ item.experience.title }}</span>
                      </div>
                    </td>
                    <td class="text-right">{{ formatPoints(item.points) }}</td>
                    <td><span :class="'badge badge-' + voucherStatus(item.status).variant">{{ voucherStatus(item.status).label }}</span></td>
                    <td class="text-right">
                      <router-link tag="a" :to="'/experiences/vouchers/' + item.protocol" class="btn btn-default btn-sm text-uppercase">Ver</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="d-md-none">
            <div v-for="item in filtered" :key="'m' + item.protocol" class="ds-box">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <strong class="notranslate">{{ item.protocol }}</strong>
                <span :class="'badge badge-' + voucherStatus(item.status).variant">{{ voucherStatus(item.status).label }}</span>
              </div>
              <p class="mb-1">{{ item.experience.title }}</p>
              <p class="text-muted mb-3">{{ formatPoints(item.points) }} · {{ formatDate(item.date) }}</p>
              <router-link tag="a" :to="'/experiences/vouchers/' + item.protocol" class="btn btn-default btn-block text-uppercase">Ver</router-link>
            </div>
          </div>
        </template>
      </template>
    </div>
  </Layout>
</template>
